module.exports = __webpack_public_path__ + "static/media/Inactive.c40efef7.png";